import React, { useEffect, useState } from 'react'
import './index.scss'
import { get, useFormContext, useFormState } from 'react-hook-form'
import clsx from 'clsx'
import FieldErrorSectionForm from '@Fields/FieldErrorSectionForm'
import { doesFieldHaveFocus } from '@App/common/utils'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { RadioFormFieldProps } from '@App/forms/common/radio-discriminated-form-field'

const RadioButtonForm = (props: RadioFormFieldProps) => {
    const formState = useFormState()
    const { register, watch } = useFormContext()
    const [hasFocus, setFocus] = useState(false)

    const { name, registerOptions, mainColor = true, options, tooltipType, tooltipPopupText } = props

    useEffect(() => {
        setFocus(doesFieldHaveFocus(name))
    }, [])

    const setFocusIfNotDisabled = (isFocused: boolean) => {
        if ((!!registerOptions && !registerOptions.disabled) || !registerOptions) {
            setFocus(isFocused)
        }
    }
    const disabled = !!registerOptions && registerOptions.disabled
    const fieldValue = watch(name)
    const error = get(formState.errors, name)
    const outerDivClassNames = clsx(
        mainColor ? 'main-color-set' : 'second-color-set',
        'input-radio-form-component',
        hasFocus && 'focused',
        error && 'error',
        disabled && 'disabled',
        !!fieldValue && 'filled'
    )

    const registerResult = register(name, registerOptions)

    return (
        <>
            {options.map((option) => (
                <div className={outerDivClassNames} key={name + '-' + option.name}>
                    {tooltipType && tooltipPopupText && <CustomToolTip type={tooltipType} info={tooltipPopupText} />}

                    <input
                        {...registerResult}
                        onFocus={() => setFocusIfNotDisabled(true)}
                        onBlur={(e) => registerResult.onBlur(e).then(() => setFocusIfNotDisabled(false))}
                        name={name}
                        defaultChecked={option.default}
                        value={option.name}
                        id={`${name}-${option.name}`}
                        data-testid={'radio-input.' + option.name}
                        type="radio"
                    />
                    <label className="input-radio-form-label" htmlFor={name}>
                        {option.label}
                    </label>
                    <FieldErrorSectionForm name={name} assistiveText="" visibility={{ assistive: false }} required />
                </div>
            ))}
        </>
    )
}

export default RadioButtonForm
